import auth from "@/router/middlewares/auth";

const routes = [
    {
        path: '/experts',
        name: 'experts.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Experts",
            authRequired: true,
        },
        component: () => import('../views/experts/index.vue')
    },
    {
        path: '/experts/:id',
        name: 'experts.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails Experts",
            authRequired: true,
        },
        component: () => import('../views/experts/show.vue')
    },
    {
        path: '/planification-activites',
        name: 'experts.manage',
        meta: {
            middleware: [
                auth,
            ],
            title: "Programmation activités", authRequired: true,
        },
        component: () => import('../views/experts/index.vue')
    },
    {
        path: '/suivi-experts',
        name: 'experts.report',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivi experts", authRequired: true,
        },
        component: () => import('../views/experts/index.vue')
    },
   {
        path: '/livrables-experts',
        name: 'experts.deliverables',
        meta: {
            middleware: [
                auth,
            ],
            title: "Livrables experts", authRequired: true,
        },
        component: () => import('../views/experts/index.vue')
    },


    {
        path: '/folders/:id',
        name: 'folders.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Fichiers", authRequired: true,
        },
        component: () => import('../views/folders/show.vue')
    },
    {
        path: '/folders',
        name: 'folders.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Dossiers spécifiques", authRequired: true,
        },
        component: () => import('../views/folders/index.vue')
    },
    {
        path: '/households',
        name: 'households.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Ménages bénéficiaires", authRequired: true,
        },
        component: () => import('../views/households/index.vue')
    },
    {
        path: '/survey-sites',
        name: 'survey-sites.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Sites aménagé", authRequired: true,
        },
        component: () => import('../views/survey-sites/index.vue')
    },
    {
        path: '/outputs/:type',
        name: 'outputs.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Livrable", authRequired: true,
        },
        component: () => import('../views/outputs/index.vue')
    },
    {
        path: '/outputs/:type/:id',
        name: 'outputs.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Livrable", authRequired: true,
        },
        component: () => import('../views/outputs/show.vue')
    },
    {
        path: '/beneficiaries',
        name: 'beneficiaries.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Bénéficiaire", authRequired: true,
        },
        component: () => import('../views/beneficiaries/index.vue')
    },
    {
        path: '/beneficiaries/create',
        name: 'beneficiaries.create',
        meta: {
            middleware: [
                auth,
            ],
            title: "Nouveau bénéficiare", authRequired: true,
        },
        component: () => import('../views/beneficiaries/create.vue')
    },
    {
        path: '/beneficiaries/:id',
        name: 'beneficiaries.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails agent", authRequired: true,
        },
        component: () => import('../views/beneficiaries/show.vue')
    },
    {
        path: '/beneficiaries/:id/edit',
        name: 'beneficiaries.edit',
        meta: {
            middleware: [
                auth,
            ],
            title: "Bénéficiaire", authRequired: true,
        },
        component: () => import('../views/beneficiaries/create.vue')
    },
    {
        path: '/sites',
        name: 'sites.index',
        meta: {
            middleware: [
                auth,
            ],
            //title: i18n.$t('support-types'), authRequired: true,
            title: "Sites", authRequired: true,
        },
        component: () => import('../views/sites/index.vue')
    },
    {
        path: '/managers',
        name: 'managers.index',
        meta: {
            middleware: [
                auth,
            ],
            //title: i18n.$t('support-types'), authRequired: true,
            title: "Responsable", authRequired: true,
        },
        component: () => import('../views/configs/managers/index.vue')
    },
    {
        path: '/sites/:id',
        name: 'sites.show',
        meta: {
            middleware: [
                auth,
            ],
            //title: i18n.$t('support-types'), authRequired: true,
            title: "Détails du site", authRequired: true,
        },
        component: () => import('../views/sites/show.vue')
    },

    {
        path: '/companies',
        name: 'companies.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Entreprises", authRequired: true,
        },
        component: () => import('../views/companies/index.vue')
    },
    {
        path: '/partners',
        name: 'partners.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Partenaire", authRequired: true,
        },
        component: () => import('../views/partners/index.vue')
    },
    {
        path: '/infrastructures',
        name: 'infrastructures.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Infrastructures", authRequired: true,
        },
        component: () => import('../views/infras/index.vue')
    },
    {
        path: '/infrastructures/create',
        name: 'infrastructures.create',
        meta: {
            middleware: [
                auth,
            ],
            title: "Infrastructures", authRequired: true,
        },
        component: () => import('../views/infras/create.vue')
    },
    {
        path: '/infrastructures/:id/edit',
        name: 'infrastructures.edit',
        meta: {
            middleware: [
                auth,
            ],
            title: "Infrastructures", authRequired: true,
        },
        component: () => import('../views/infras/create.vue')
    },
    {
        path: '/infrastructures/:id',
        name: 'infrastructures.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Infrastructures", authRequired: true,
        },
        component: () => import('../views/infras/show.vue')
    },
    {
        path: '/followups',
        name: 'followups.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivis", authRequired: true,
        },
        component: () => import('../views/followups/index.vue')
    },
    {
        path: '/conventions-report',
        name: 'conventions.report',
        meta: {
            middleware: [
                auth,
            ],
            title: "Rapport conventions", authRequired: true,
        },
        component: () => import('../views/conventions/index.vue')
    },
    {
        path: '/conventions',
        name: 'conventions.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Conventions", authRequired: true,
        },
        component: () => import('../views/conventions/index.vue')
    },
    {
        path: '/conventions/:id/edit',
        name: 'conventions.edit',
        meta: {
            middleware: [
                auth,
            ],
            title: "Conventions", authRequired: true,
        },
        component: () => import('../views/conventions/create.vue')
    },
    {
        path: '/conventions/create',
        name: 'conventions.create',
        meta: {
            middleware: [
                auth,
            ],
            title: "Conventions", authRequired: true,
        },
        component: () => import('../views/conventions/create.vue')
    },
    {
        path: '/conventions/:id',
        name: 'conventions.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Conventions", authRequired: true,
        },
        component: () => import('../views/conventions/show.vue')
    },
    // Protocoles
    {
        path: '/protocoles',
        name: 'protocoles.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Protocoles", authRequired: true,
            permission: "browse-protocole",
        },
        component: () => import('../views/protocoles/index.vue')
    },
    {
        path: '/protocoles/create',
        name: 'protocoles.create',
        meta: {
            middleware: [
                auth,
            ],
            title: "Nouveau protocole", authRequired: true,
            permission: "store-protocole",
        },
        component: () => import('../views/protocoles/create.vue')
    },
    {
        path: '/protocoles/:id/edit',
        name: 'protocoles.edit',
        meta: {
            middleware: [
                auth,
            ],
            title: "Modifier protocole", authRequired: true,
            permission: "update-protocole",
        },
        component: () => import('../views/protocoles/create.vue')
    },
    {
        path: '/protocoles/:id',
        name: 'protocoles.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails protocole", authRequired: true,
            permission: "read-protocole",
        },
        component: () => import('../views/protocoles/show.vue')
    },
    // Gestion protocoles - sous-menus
    {
        path: '/protocoles-parametrage',
        name: 'protocoles.parametrage',
        meta: {
            middleware: [
                auth,
            ],
            title: "Paramétrage protocoles", authRequired: true,
            permission: "browse-protocole",
        },
        component: () => import('../views/protocoles/index.vue')
    },
    {
        path: '/protocoles-activites',
        name: 'protocoles.activites',
        meta: {
            middleware: [
                auth,
            ],
            title: "Paramétrage activités", authRequired: true,
            permission: "browse-protocole",
        },
        component: () => import('../views/protocoles/index.vue')
    },
    {
        path: '/protocoles-cadre-logique',
        name: 'protocoles.cadre-logique',
        meta: {
            middleware: [
                auth,
            ],
            title: "Cadre logique protocoles", authRequired: true,
            permission: "browse-protocole",
        },
        component: () => import('../views/protocoles/index.vue')
    },
    {
        path: '/protocoles-suivi-activites',
        name: 'protocoles.suivi-activites',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivi activités protocoles", authRequired: true,
            permission: "browse-protocole",
        },
        component: () => import('../views/protocoles/index.vue')
    },
    {
        path: '/protocoles-suivi-financier',
        name: 'protocoles.suivi-financier',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivi financier protocoles", authRequired: true,
            permission: "browse-protocole",
        },
        component: () => import('../views/protocoles/tors/index.vue')
    },
    {
        path: '/protocoles-tors/:id',
        name: 'protocoles.tors.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails TDR", authRequired: true,
            permission: "read-protocole",
        },
        component: () => import('../views/protocoles/tors/show.vue')
    },
    {
        path: '/planifications',
        name: 'planifications.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Planification", authRequired: true,
        },
        component: () => import('../views/planifications/index.vue')
    },
    {
        path: '/disbursements',
        name: 'disbursements.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Décaissement", authRequired: true,
        },
        component: () => import('../views/disbursements/index.vue')
    },
    {
        path: '/disbursements/:id',
        name: 'disbursements.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails Décaissement", authRequired: true,
        },
        component: () => import('../views/disbursements/show.vue')
    },
    {
        path: '/disbursement-demands',
        name: 'disbursement-demands.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Appel de fonds", authRequired: true,
        },
        component: () => import('../views/disbursement-demands/index.vue')
    },
    {
        path: '/urgent-infos',
        name: 'urgent-infos',
        meta: {
            middleware: [
                auth,
            ],
            title: "Infos urgentes", authRequired: true,
        },
        component: () => import('../views/urgent-infos/index.vue')
    },
    {
        path: '/urgent-infos/:id',
        name: 'urgent-infos-show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails Info urgente", authRequired: true,
        },
        component: () => import('../views/urgent-infos/show.vue')
    },
    {
        path: '/urgent-infos/:id/edit',
        name: 'urgent-infos-edit',
        meta: {
            middleware: [
                auth,
            ],
            title: "Modifier Info urgente", authRequired: true,
        },
        component: () => import('../views/urgent-infos/edit.vue')
    },
    {
        path: '/disbursement-demands/:id',
        name: 'disbursement-demands.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails Appel de fonds", authRequired: true,
        },
        component: () => import('../views/disbursement-demands/show.vue')
    },
    {
        path: '/tors',
        name: 'tors.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "TDRS", authRequired: true,
        },
        component: () => import('../views/tors/index.vue')
    },
    {
        path: '/tors/:id',
        name: 'tors.show',
        meta: {
            middleware: [
                auth,
            ],
            title: "Détails TDRS", authRequired: true,
        },
        component: () => import('../views/tors/show.vue')
    },
    {
        path: '/gestion-execution-physique',
        name: 'manage.ph.exec',
        meta: {
            middleware: [
                auth,
            ],
            title: "Programmation activités", authRequired: true,
        },
        component: () => import('../views/conventions/index.vue')
    },
    {
        path: '/suivi-execution-physique',
        name: 'report.ph.exec',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivi activités", authRequired: true,
        },
        component: () => import('../views/conventions/index.vue')
    },
    {
        path: '/gestion-execution-financiere',
        name: 'manage.fin.exec',
        meta: {
            middleware: [
                auth,
            ],
            title: "Gestion exécution financiere", authRequired: true,
        },
        component: () => import('../views/disbursements/index.vue')
    },
    {
        path: '/report-execution-financiere',
        name: 'report.fin.exec',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivi exécution financiere", authRequired: true,
        },
        component: () => import('../views/disbursements/index.vue')
    },
    {
        path: '/gestion-indicateurs',
        name: 'manage.indic',
        meta: {
            middleware: [
                auth,
            ],
            title: "Cadre logique", authRequired: true,
        },
        component: () => import('../views/conventions/index.vue')
    },
    {
        path: '/suivi-indicateurs',
        name: 'report.indic',
        meta: {
            middleware: [
                auth,
            ],
            title: "Suivi indicateur", authRequired: true,
        },
        component: () => import('../views/conventions/index.vue')
    },

    // Recommandations de revue
    {
        path: '/recommandations',
        name: 'review-recommendations.index',
        meta: {
            middleware: [auth],
            title: "Recommandations de revue",
            authRequired: true,
        },
        component: () => import('../views/review-recommendations/index.vue')
    },
    // ===== Pôles =====
    {
        path: '/poles',
        name: 'poles.index',
        meta: {
            middleware: [auth],
            title: "Pôles",
            authRequired: true,
            permission: "browse-pole",
        },
        component: () => import('../views/poles/index.vue')
    },
    // ===== Investissements =====
    {
        path: '/investissements/tableau-de-bord',
        name: 'investissements.dashboard',
        meta: {
            middleware: [auth],
            title: "Tableau de bord investissements",
            authRequired: true,
            permission: "browse-investment",
        },
        component: () => import('../views/investissements/dashboard.vue')
    },
    {
        path: '/investissements',
        name: 'investissements.index',
        meta: {
            middleware: [auth],
            title: "Investissements",
            authRequired: true,
            permission: "browse-investment",
        },
        component: () => import('../views/investissements/index.vue')
    },
    {
        path: '/investissements/create',
        name: 'investissements.create',
        meta: {
            middleware: [auth],
            title: "Nouvel investissement",
            authRequired: true,
            permission: "store-investment",
        },
        component: () => import('../views/investissements/create.vue')
    },
    {
        path: '/investissements/import',
        name: 'investissements.import',
        meta: {
            middleware: [auth],
            title: "Import d'investissements",
            authRequired: true,
            permission: "import-investment",
        },
        component: () => import('../views/investissements/import.vue')
    },
    {
        path: '/investissements/carte',
        name: 'investissements.carte',
        meta: {
            middleware: [auth],
            title: "Carte des investissements",
            authRequired: true,
            permission: "browse-investment",
        },
        component: () => import('../views/investissements/carte.vue')
    },
    {
        path: '/investissements/:id/edit',
        name: 'investissements.edit',
        meta: {
            middleware: [auth],
            title: "Modifier investissement",
            authRequired: true,
            permission: "update-investment",
        },
        component: () => import('../views/investissements/create.vue')
    },
    {
        path: '/investissements/:id',
        name: 'investissements.show',
        meta: {
            middleware: [auth],
            title: "Détail investissement",
            authRequired: true,
            permission: "read-investment",
        },
        component: () => import('../views/investissements/show.vue')
    },
    // ===== Plans d'affaires =====
    {
        path: '/plan-beneficiaries',
        name: 'plan-beneficiaries.index',
        meta: {
            middleware: [auth],
            title: "Bénéficiaires PA",
            authRequired: true,
            permission: "browse-plan-beneficiary",
        },
        component: () => import('../views/plan-beneficiaries/index.vue')
    },
    {
        path: '/plan-beneficiaries/create',
        name: 'plan-beneficiaries.create',
        meta: {
            middleware: [auth],
            title: "Nouveau bénéficiaire",
            authRequired: true,
            permission: "store-plan-beneficiary",
        },
        component: () => import('../views/plan-beneficiaries/create.vue')
    },
    {
        path: '/plan-beneficiaries/:id/edit',
        name: 'plan-beneficiaries.edit',
        meta: {
            middleware: [auth],
            title: "Modifier bénéficiaire",
            authRequired: true,
            permission: "update-plan-beneficiary",
        },
        component: () => import('../views/plan-beneficiaries/create.vue')
    },
    {
        path: '/plan-beneficiaries/:id',
        name: 'plan-beneficiaries.show',
        meta: {
            middleware: [auth],
            title: "Détails bénéficiaire",
            authRequired: true,
            permission: "read-plan-beneficiary",
        },
        component: () => import('../views/plan-beneficiaries/show.vue')
    },
    {
        path: '/business-plans',
        name: 'business-plans.index',
        meta: {
            middleware: [auth],
            title: "Plans d'affaires",
            authRequired: true,
            permission: "browse-business-plan",
        },
        component: () => import('../views/business-plans/index.vue')
    },
    {
        path: '/business-plans/create',
        name: 'business-plans.create',
        meta: {
            middleware: [auth],
            title: "Nouveau plan d'affaires",
            authRequired: true,
            permission: "store-business-plan",
        },
        component: () => import('../views/business-plans/create.vue')
    },
    {
        path: '/business-plans/:id',
        name: 'business-plans.show',
        meta: {
            middleware: [auth],
            title: "Détails plan d'affaires",
            authRequired: true,
            permission: "read-business-plan",
        },
        component: () => import('../views/business-plans/show.vue')
    },
    {
        path: '/fnda-transfer-batches',
        name: 'fnda-transfer-batches.index',
        meta: {
            middleware: [auth],
            title: "Envois groupés FNDA",
            authRequired: true,
            permission: "browse-fnda-transfer-batch",
        },
        component: () => import('../views/fnda-transfer-batches/index.vue')
    },
    {
        path: '/fnda-transfer-batches/create',
        name: 'fnda-transfer-batches.create',
        meta: {
            middleware: [auth],
            title: "Nouvel envoi groupé FNDA",
            authRequired: true,
            permission: "store-fnda-transfer-batch",
        },
        component: () => import('../views/fnda-transfer-batches/create.vue')
    },
    {
        path: '/fnda-transfer-batches/:id',
        name: 'fnda-transfer-batches.show',
        meta: {
            middleware: [auth],
            title: "Détails envoi groupé FNDA",
            authRequired: true,
            permission: "read-fnda-transfer-batch",
        },
        component: () => import('../views/fnda-transfer-batches/show.vue')
    },
];


export default routes;